module.exports = __webpack_public_path__ + "80bd7c8620249fbcf6ffc90cc7c82009.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/spider.png
// module id = 2329
// module chunks = 0